<template>
  <div>
  <Base-header class="pb-6 pb-7 bg-gradient-success"></Base-header>
    <div id="tableContainer" class="bg-white"></div>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
import BaseHeader from "@/components/admin/BaseHeader";
import SurveyService from '@/services/survey.service';
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";

window.jsPDF = jsPDF;
window.XLSX = XLSX;

import "jspdf-autotable"

import { Tabulator } from "survey-analytics/survey.analytics.tabulator";

import "survey-analytics/survey.analytics.tabulator.css";
import "tabulator-tables/dist/css/tabulator.min.css";

/* eslint-disable vue/no-unused-components */
export default {
  components: {
    SurveyVue, BaseHeader
  },

  data() {
    return {
       data: [{

       }]
    }
  },
  mounted() {

    SurveyService.showResult(this.$route.params.id).then(res => {
      this.data = res.data.survey;
    }).catch(error => console.error(error));

    SurveyService.showEditor(this.$route.params.id).then(res => {
      var survey = new SurveyVue.Model(res.data.survey.elements);
      var surveyAnalyticsDataTables = new Tabulator(survey, this.data);
      surveyAnalyticsDataTables.render(document.getElementById("tableContainer"));
    }).catch(error => console.error(error));

  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.sa-commercial {
    display: none!important;
}
</style>
